<script>
  import { ReviewForm as Form } from '$client';
  export let data;
</script>

<section id="main" class="custom-page margin-block">
  {#if data.doc}
    <div class="container">
      {@html data.doc}
    </div>
  {/if}

  {#if data.form}
    <Form data={data.form} isH1={true} />
  {/if}
</section>

<style lang="scss">
  .custom-page {
    :global(#form form > div) {
      grid-template-columns: 1fr;
    }

    :global(#form form > div > div) {
      grid-column-start: 1 !important;
      min-width: 100%;
    }
  }
</style>
